<template>
  <v-row no-gutters style="padding: 15px" 
    :class="layout === 'profile' ? 'white' : ''"
  >
    <v-col :cols="12" v-if="layout === 'profile'" class="mb-5">
      <v-layout align-center>
      <span class="contact-text">
          <svgicon icon="phone" width="1.75rem" height="1.75rem" color="#404a57"></svgicon>
            CELULAR
            {{ user.phone_number }}
            <span class="admin-text ml-5"
            v-html="user.admin ? 'USUARIO ASIGNADO A ' + (user.admin).toUpperCase() : 'USUARIO ACTUALMENTE NO ASIGNADO'"
          />
        </span>
      </v-layout>
    </v-col>
    <v-col :cols="6">
        <v-card flat 
          :color="backgroundColor" class="pr-12"
        >
            <v-card-title class="pa-0 title-label">
                HISTORIAL DE CONTACTOS
            </v-card-title>

            <v-card-text class="pa-0 contact-history-thread">

                <div v-for="(contactItem, index) in contactHistory"
                     :key="index" class="contact-history-item">
                    <div class="info-text"> 
                      <i>
                        {{humanReadableDateTime(contactItem.created_at) }} -  {{contactItem.contact_by_name}}
                      </i>
                    </div>
                    <div class="title-text">
                      {{getResultOptionTextFromValue(contactItem.contact_history_result_option_id)}}
                    </div>
                    <div class="mb-5 comment-text">
                      <i>
                        {{contactItem.comment}}
                      </i>
                    </div>
                </div>

                <loading-container :size="40" v-if="loading" />
            </v-card-text>

        </v-card>
    </v-col>

    <v-col :cols="6" >

        <v-card  
          flat 
          :color="backgroundColor"
        >
            <v-card-title class="pa-0 title-label">
                NUEVO CONTACTO
            </v-card-title>
            <v-card-text class="pa-0 mt-5">
                <form @submit.prevent="onContactFormSubmit(user)">
                    <span class="label mb-1"> RESULTADO </span>
                    <v-select
                            flat
                            solo
                            outlined
                            :items="resultOptions"
                            v-model="selectedResultOption"
                            item-text="text"
                            item-value="value"
                            label="Selecciona una opción"
                    ></v-select>
                    <span class="label mb-1"> AÑADIR UN COMENTARIO </span>
                    <v-textarea
                            outlined
                            flat
                            solo
                            name="input-7-4"
                            label=""
                            v-model="comment"
                    ></v-textarea>
                    <v-container row no-gutters justify-end>
                      <div>
                          <v-btn class="cancel-button primary--text" @click="cancelInput" color="primary" outlined>
                            Cancelar
                          </v-btn>
                      </div>
                      <div >
                          <v-btn  type="submit" color="primary" class="ml-5 mr-5 form-button" :disabled="loading || !canSubmitForm">
                            Guardar
                          </v-btn>
                      </div>
                    </v-container>
                </form>
            </v-card-text>
        </v-card>
    </v-col>
</v-row>
</template>

<script>
  import Constants from '../constants'

  export default {
    name: 'ContactHistory',

    props: {
      user: {
        type: Object,
        required: true
      },
      layout: {
        type: String,
        default: 'list'
      }
    },

    data: () => ({
      resultOptions: Constants.resultOptions,
      selectedResultOption:'',
      comment:'',
    }),

    computed: {
      contactHistory() {
          return this.$store.getters['contact_history/contactHistory']
      },

      loading () {
        return this.$store.getters['contact_history/contactHistoryLoading']
      },

      canSubmitForm () {
        return this.selectedResultOption !== '';
      },

      backgroundColor () {
        if (this.layout === 'profile') return '#ffffff';
        return this.user.is_intervened ? '#c3ecff' : '#f5f8fc'
      }
    },


    methods: {
      clearForm() {
          this.selectedResultOption='';
          this.comment='';
      },

      cancelInput() {
        this.clearForm()
        this.$emit('cancelComment')
      },

      onContactFormSubmit(user) {
        const payload = {
          patient_id: user.id,
          result_option_id: this.selectedResultOption,
          comment: this.comment
        }
        this.$store.dispatch('contact_history/addContactHistory', payload);
        this.clearForm()
        user.is_intervened=true;
      },

      getResultOptionTextFromValue(value) {
        return this.resultOptions.find(x => x.value === value).text
      },
    }
  }
</script>

<style lang="scss" scoped>

  .title-label {
    color: #12729a;
    font-weight: 600;
  }

  .label {
    color: #313b47;
    font-size: 0.95rem;
  }

  .contact-history-thread {

    .info-text {
      color: #2a6680;
      &:before {
        content: '';
        display: inline-block;
        width: 10px;
        height: 10px;
        background: #2a6680;
        border-radius: 50%;
      }
    }
    .title-text {
      color: #404a57;
      font-size: 1.125rem;
      border-left: 1px dashed #2a6680;
      padding-left: 12px;
      margin-left: 0.2rem;
    }
    .comment-text {
      color: #555f6b;
      line-height: 1.24;
      font-size: 1.075rem;
      border-left: 1px dashed #2a6680;
      padding-left: 12px;
      margin-left: 0.2rem;
    }
  }

  .contact-text {
      font-weight: 600;
      color: #222c38;
      font-size: 1.125rem;
    }

    .admin-text {
      color: #12729a;
      font-weight: 600;
    }

</style>
